import { LoadingComponent } from './loading.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderInterceptor } from '../../core/helpers/loading.interceptor';





@NgModule({
  declarations: [LoadingComponent],
  imports: [
    CommonModule,MatProgressSpinnerModule
  ],
  exports: [LoadingComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }],
})
export class LoadingModule { }
